import React, { FC } from 'react';
import userIcon from '../../../../assets/img/icons/ic-user.svg';
import { EventData } from '../../../../models/EventData';
import { useStyles } from './styles';

interface Props {
    eventData: EventData;
}

const ViewersCount: FC<Props> = ({ eventData }) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <img src={userIcon} alt="" />
            <p>{eventData && eventData.attendees_users?.length} Viewers</p>
        </div>
    );
};
export default ViewersCount;
